import Mode from "./Mode";
import ConversionExerciseGenerator from "../exerciseGenerator/ConversionExerciseGenerator";
import NumberSystems from "../NumberSystems";
import ResultChecker from "../resultChecker/DefaultResultChecker";
import GradualDivisionExerciseGenerator from "../exerciseGenerator/GradualDivisionExerciseGenerator";
import GradualMultiplicationExerciseGenerator from "../exerciseGenerator/GradualMultiplicationExerciseGenerator";
import ArithmeticExerciseGenerator from "../exerciseGenerator/ArithmeticExerciseGenerator";
import CalculationTypes from "../CalculationTypes";
import SignBitExerciseGenerator from "../exerciseGenerator/SignBitExerciseGenerator";
import OneComplementExerciseGenerator from "../exerciseGenerator/OneComplementExerciseGenerator";
import TwoComplementExerciseGenerator from "../exerciseGenerator/TwoComplementExerciseGenerator";
import Excess127ExerciseGenerator from "../exerciseGenerator/Excess127ExerciseGenerator";
import IEEE754ExerciseGenerator from "../exerciseGenerator/IEEE754ExerciseGenerator";
import FloatingPointConversionExerciseGenerator from "../exerciseGenerator/FloatingPointConversionExerciseGenerator";

const Modes =  {
    BINARY_TO_DECIMAL: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.BINARY,
            NumberSystems.DECIMAL
        ],
        [4,8],
        ConversionExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    DECIMAL_TO_BINARY: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.DECIMAL,
            NumberSystems.BINARY
        ],
        [4,8],
        ConversionExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    BINARY_TO_DECIMAL_FLOAT: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.BINARY,
            NumberSystems.DECIMAL
        ],
        [],
        FloatingPointConversionExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement",
        ["3_integer_4_decimal_places"]
    ),
    DECIMAL_TO_BINARY_FLOAT: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.DECIMAL,
            NumberSystems.BINARY
        ],
        [],
        FloatingPointConversionExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement",
        ["3_integer_4_decimal_places"]
    ),
    HEXADECIMAL_TO_BINARY: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.HEXADECIMAL,
            NumberSystems.BINARY
        ],
        [4,8],
        ConversionExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    BINARY_TO_HEXADECIMAL: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.BINARY,
            NumberSystems.HEXADECIMAL
        ],
        [4,8],
        ConversionExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    HEXADECIMAL_TO_DECIMAL: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.HEXADECIMAL,
            NumberSystems.DECIMAL
        ],
        [4,8],
        ConversionExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    DECIMAL_TO_HEXADECIMAL: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.DECIMAL,
            NumberSystems.HEXADECIMAL
        ],
        [4,8],
        ConversionExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    OCTAL_TO_DECIMAL: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.OCTAL,
            NumberSystems.DECIMAL
        ],
        [4,8],
        ConversionExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    DECIMAL_TO_OCTAL: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.DECIMAL,
            NumberSystems.OCTAL
        ],
        [4,8],
        ConversionExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    HEXADECIMAL_TO_BINARY_TO_OCTAL: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.HEXADECIMAL,
            NumberSystems.BINARY,
            NumberSystems.OCTAL
        ],
        [4,8],
        ConversionExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement",
        ["steps_in_binary"]
    ),
    OCTAL_TO_BINARY_TO_HEXADECIMAL: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.OCTAL,
            NumberSystems.BINARY,
            NumberSystems.HEXADECIMAL
        ],
        [4,8],
        ConversionExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement",
        ["steps_in_binary"]
    ),
    DECIMAL_TO_BINARY_GRADUAL_DIVISION: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.DECIMAL,
            NumberSystems.BINARY
        ],
        [8],
        GradualDivisionExerciseGenerator,
        ResultChecker,
        "GradualExerciseElement",
        ["integer_part"]
    ),
    DECIMAL_TO_BINARY_GRADUAL_MULTIPLICATION: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.DECIMAL,
            NumberSystems.BINARY
        ],
        [8],
        GradualMultiplicationExerciseGenerator,
        ResultChecker,
        "GradualExerciseElement",
        ["decimal_part"]
    ),
    BINARY_ADDITION: new Mode(
        CalculationTypes.ADDITION,
        [
            NumberSystems.BINARY
        ],
        [8],
        ArithmeticExerciseGenerator,
        ResultChecker,
        "ArithmeticElement"
    ),
    BINARY_SUBTRACTION: new Mode(
        CalculationTypes.SUBTRACTION,
        [
            NumberSystems.BINARY
        ],
        [8],
        ArithmeticExerciseGenerator,
        ResultChecker,
        "ArithmeticElement"
    ),
    DECIMAL_TO_BINARY_SIGN_BIT_8_BIT: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.DECIMAL,
            NumberSystems.BINARY,
        ],
        [8],
        SignBitExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    BINARY_SIGN_BIT_TO_DECIMAL_8_BIT: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.BINARY,
            NumberSystems.DECIMAL,
        ],
        [8],
        SignBitExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    DECIMAL_TO_BINARY_ONES_COMPLEMENT_8_BIT: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.DECIMAL,
            NumberSystems.BINARY,
        ],
        [8],
        OneComplementExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    BINARY_ONES_COMPLEMENT_TO_DECIMAL_8_BIT: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.BINARY,
            NumberSystems.DECIMAL,
        ],
        [8],
        OneComplementExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    DECIMAL_TO_BINARY_TWOS_COMPLEMENT_8_BIT: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.DECIMAL,
            NumberSystems.BINARY
        ],
        [8],
        TwoComplementExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    BINARY_TWOS_COMPLEMENT_TO_DECIMAL_8_BIT: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.BINARY,
            NumberSystems.DECIMAL
        ],
        [8],
        TwoComplementExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    DECIMAL_TO_BINARY_EXCESS_127_8_BIT: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.DECIMAL,
            NumberSystems.BINARY
        ],
        [8],
        Excess127ExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    BINARY_TO_DECIMAL_EXCESS_127_8_BIT: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.BINARY,
            NumberSystems.DECIMAL
        ],
        [8],
        Excess127ExerciseGenerator,
        ResultChecker,
        "ConversionExerciseElement"
    ),
    DECIMAL_FLOATING_POINT_TO_IEEE_754_32_BIT_8_INTEGERS_4_DECIMALS: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.DECIMAL,
            NumberSystems.BINARY
        ],
        [32],
        IEEE754ExerciseGenerator,
        ResultChecker,
        "IEEE754ExerciseElementDecimalToIEEE"
    ),
    IEEE_754_32_BIT_8_INTEGERS_4_DECIMALS_TO_DECIMAL_FLOATING_POINT: new Mode(
        CalculationTypes.CONVERSION,
        [
            NumberSystems.BINARY,
            NumberSystems.DECIMAL
        ],
        [32],
        IEEE754ExerciseGenerator,
        ResultChecker,
        "IEEE754ExerciseElementIEEEToDecimal"
    ),
};
export default Modes;